const specialSlider = () => {
  const specialSliders = document.querySelectorAll('.slider-list');

  if (specialSliders.length === 0) {
    return;
  }

  if (specialSliders.length !== 0) {
    const getOutItem = (parentList) => {
      const items = parentList.querySelectorAll('.slider-list__item');
      items.forEach((item) => {
        if (item.getBoundingClientRect().right > parentList.getBoundingClientRect().right) {
          item.classList.add('slider-list__item--out');
        } else {
          item.classList.remove('slider-list__item--out');
        }
      });
    };

    const createSliders = () => {
      specialSliders.forEach((elem) => {
        const slider = new Swiper(elem.querySelector('.swiper-container'), {
          slidesPerView: 'auto',
          spaceBetween: 37,
          watchOverflow: true,
          slideToClickedSlide: true,
          slidesOffsetAfter: 37,

          breakpoints: {
            320: {
              spaceBetween: 18,
            },
            768: {
              spaceBetween: 37,
            },
          },
        });

        getOutItem(elem, 'special__item');

        slider.on('sliderMove', function () {
          getOutItem(elem, 'special__item');
        });

        slider.on('slideChangeTransitionEnd', function () {
          getOutItem(elem, 'special__item');
        });

        slider.on('slideNextTransitionEnd', function () {
          getOutItem(elem, 'special__item');
        });

        slider.on('slideResetTransitionEnd', function () {
          getOutItem(elem, 'special__item');
        });
      });
    };

    createSliders();

    window.addEventListener('resize', createSliders);

  }
};

export {specialSlider};
